import { FormGroup } from '@angular/forms';
import { ToastService } from '../service/toast.service';

export abstract class BaseFormComponent {
  constructor(protected toastService: ToastService) {}

  protected validateForm(
    form: FormGroup,
    errorMessage: string = 'Completa los campos requeridos.'
  ): boolean {
    if (form.invalid) {
      form.markAllAsTouched();
      this.toastService.showMessages('error', [errorMessage]);
      return false;
    }
    return true;
  }

  protected showApiError(err: any, fallback: string): void {
    const mensajes = err?.error?.listMessage?.length
      ? err.error.listMessage
      : [fallback];
    this.toastService.showMessages('error', mensajes);
  }
}
